import { connect } from "react-redux";
import React from "react";
import moment from "moment";
import * as XLSX from "xlsx-js-style";

import {
  DatePicker,
  PageHeader,
  Descriptions,
  Table,
  Button,
  Row,
  Col,
  Empty,
  Space,
  message,
} from "antd";

import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";

import { LanguageContext } from "../../context/LanguageContext";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
import { PoliceSideActions } from "../../_actions/police.side.actions";
import _ from "lodash";
import { professionalAction } from "../../_actions";

const columnKeyMap = {
  sr_no: "sr.no",

  crime_district: "crime_police_station",

  district_name: "law_and_section",

  name: "name_of_the_accused",

  memberName: "incident_details",

  report_date: "date",

  notice_district: "notice_police",

  action_taken_police_station: "action_taken_police_station",

  preventive_name: "preventive_action",

  districtName: "accused_police_station",

  totalCrimeCount: "total_crimes",
};

class NewDailyReports extends React.Component {
  static contextType = LanguageContext;

  state = {
    startDate: "",
    report4_API_loader: false,
    data: {
      FIR: [],
      Arrest: [],
      Notice: [],
      PreventiveAction: [],
      NCR: [],
      pagination: {
        current: 1,
        pageSize: 10,
      },
    },
    pdfDownloadLoading: false,
  };

  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.format("YYYY-MM-DD");

      this.setState({
        startDate,
      });
    } else {
      this.setState({
        startDate: "",
      });
    }
  };

  dailyReports = () => {
    const { startDate } = this.state;

    if (!startDate) {
      this.setState({ report4_API_loader: false });
      return;
    }

    this.setState({ report4_API_loader: true });

    const payload = {
      startDate,
      district:
        this.props.user.role === "2"
          ? [this.props.user.districtId]
          : this.props.user.districtId,

      cityId: this.props.user.cityId,
    };

    PoliceSideActions.dailyReports(payload)
      .then((res) => {
        if (res && res.success) {
          this.setState({
            data: res.data,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.setState({
          report4_API_loader: false,
        });
      });
  };
  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  componentDidMount() {
    const { user } = this.props;
    if (user && user.role !== "4") {
      this.getDistrictsid();
    }
    this.props.dispatch(professionalAction.getCity());
  }

  getDistrictsid = (id) => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };

  getHeaderTitle = (col, t) => {
    const key = col.key || col.dataIndex;

    const translationKey = columnKeyMap[key];

    return translationKey ? t(translationKey) : t(key) || key;
  };
  getColumnValue = (col, item, index, t) => {
    const key = col.key || col.dataIndex;

    switch (key) {
      // ✅ Common
      case "sr_no":
        return index + 1;

      // ✅ FIR + Arrest
      case "crime_district":
        return [
          item.crime_district || "-",
          `${item.registernumber || "-"} / ${
            item.registernumberYear
              ? moment(item.registernumberYear).format("YYYY")
              : "-"
          }`,
          item.report_date ? moment(item.report_date).format("DD/MM/YYYY") : "",
        ]
          .filter(Boolean)
          .join("\n");

      // ✅ Law & Section (FIR + Arrest)
      case "district_name":
        const groupedData = {};

        item?.kk_info?.forEach((i) => {
          if (!groupedData[i.rulesName]) {
            groupedData[i.rulesName] = new Set();
          }
          groupedData[i.rulesName].add(i.kalam);
        });

        const rulesText = Object.keys(groupedData)
          .map((rule) => {
            const kalams = Array.from(groupedData[rule]).join(", ");
            return `${rule} - ${kalams}`;
          })
          .join(" | ");

        return [
          rulesText || "-",
          item.investigating_officer
            ? `${t("investigating_officer")}: ${item.investigating_officer}`
            : "",
          item.mobile_no ? `${t("mobile_no")}: ${item.mobile_no}` : "",
        ]
          .filter(Boolean)
          .join("\n");

      // ✅ Name (Used in almost all tables)
      case "name":
        return [
          item.name || "-",
          item.age ? `${t("age")}: ${item.age}` : "",
          item.address ? `${t("address")}: ${item.address}` : "",
          item.accused_arrested !== undefined
            ? `${t("arrest1")}: ${
                item.accused_arrested === "Yes" ? t("yes") : t("no")
              }`
            : "",
          item.criminal_dob
            ? `${t("accused_dob")}: ${moment(item.criminal_dob).format(
                "DD/MM/YYYY",
              )}`
            : "",
          item.aadharno ? `${t("aadhaar_number")}: ${item.aadharno}` : "",
          item.mobileNumber
            ? `${t("mobile_number")}: ${item.mobileNumber}`
            : "",
        ]
          .filter(Boolean)
          .join("\n");

      // ✅ FIR
      case "memberName":
        return item.memberName || "-";

      // ✅ Arrest
      case "report_date":
        return item.report_date
          ? moment(item.report_date).format("DD/MM/YYYY")
          : "-";

      // ✅ Notice
      case "notice_district":
        return [
          item.notice_date
            ? `${t("notice_date")}: ${moment(item.notice_date).format(
                "DD/MM/YYYY",
              )}`
            : "",
          `${t("crime_police_station")}: ${item.notice_district || "-"}`,
          item.registernumber
            ? `${t("cr.no")}: ${item.registernumber}/${
                item.registernumberYear
                  ? moment(item.registernumberYear).format("YYYY")
                  : "-"
              }`
            : "",
        ]
          .filter(Boolean)
          .join("\n");

      // ✅ Preventive
      case "action_taken_police_station":
        return item.action_taken_police_station || "-";

      case "preventive_name":
        return item.preventive_name || "-";

      case "date_from":
        return [
          `${t("period_from")}: ${moment(item.date_from).format("DD/MM/YYYY")}`,
          `${t("period_to")}: ${moment(item.date_to).format("DD/MM/YYYY")}`,
        ].join("\n");

      // ✅ NCR
      case "districtName":
        return item.districtName || "-";

      case "totalCrimeCount":
        return item.totalCrimeCount || "-";

      default:
        return item[key] || "-";
    }
  };
  getExportRows = (tableData, columns) => {
    const { t } = this.context;

    return tableData.map((item, index) => {
      const row = {};

      columns.forEach((col) => {
        if (!col.title) return;

        const header = this.getHeaderTitle(col, t);
        row[header] = this.getColumnValue(col, item, index, t);
      });

      return row;
    });
  };

  downloadPdf = async (tableName, tableData, columns) => {
    const { t } = this.context;
    const arrData = this.getExportRows(tableData, columns);

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const reportTitle = `${t("daily_reports")} - ${tableName}`;
    const file_name = `${t("daily_reports")}_${tableName}_${moment().format(
      "DDMMMYYYY",
    )}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ pdfDownloadLoading: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle,
        dateRangeText: getReportDateRangeText(this.state.startDate),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ pdfDownloadLoading: false });
    }
  };

  downloadExcel = (tableName, tableData, columns) => {
    const { t } = this.context;

    const reportTitle = `${t("daily_reports")} - ${tableName}`;
    const file_name = `${t("daily_reports")}_${tableName}_${moment().format(
      "DDMMMYYYY",
    )}`;

    const arrData = this.getExportRows(tableData, columns);

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    // ✅ Column Width
    const columnWidths = Object.keys(arrData[0] || {}).map((key) => {
      const maxLength = Math.max(
        key.length,
        ...arrData.map((row) => {
          const cell = row[key] ? String(row[key]) : "";

          // 👉 split multiline and take longest line
          const longestLine = Math.max(
            ...cell.split("\n").map((line) => line.length),
          );

          return longestLine;
        }),
      );

      return {
        wch: Math.min(Math.max(maxLength + 5, 30), 80), // 🔥 padding + bigger width
      };
    });

    ws["!cols"] = columnWidths;

    // ================= Styles =================

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    // Header Style
    Object.keys(arrData[0] || {}).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });

      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    // Cell Style
    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });

        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    // ================= Header =================

    const cityName = this.getCityName(this.props?.user?.cityId || "");

    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;

    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: reportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `${moment(this.state.startDate).format("DD-MM-YYYY")}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    // ================= Footer =================

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY HH:mm",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    // ================= Merge =================

    ws["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: columnWidths.length - 1 },
      },
      {
        s: { r: 1, c: 0 },
        e: { r: 1, c: columnWidths.length - 1 },
      },
      {
        s: { r: 2, c: 0 },
        e: { r: 2, c: columnWidths.length - 1 },
      },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
    ];

    const rows = [];

    // Top header rows
    rows[0] = { hpt: 30 };
    rows[1] = { hpt: 25 };
    rows[2] = { hpt: 20 };
    rows[3] = { hpt: 30 }; // column header

    // Data rows
    arrData.forEach((row, i) => {
      const maxLines = Math.max(
        ...Object.values(row).map(
          (cell) => String(cell || "").split("\n").length,
        ),
      );

      rows[i + 4] = {
        hpt: Math.max(25, maxLines * 20), // 🔥 key fix
      };
    });

    // Footer
    rows[footerRowIndex - 1] = { hpt: 25 };

    ws["!rows"] = rows;

    // ================= Workbook =================

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  renderTableSection = (title, data, columns) => {
    return (
      <div
        style={{
          marginTop: "30px",
          background: "#fff",
          padding: "15px",
          borderRadius: "10px",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: "15px" }}
        >
          <Col>
            <h3 style={{ margin: 0 }}>{title}</h3>
          </Col>

          <Col>
            <Space>
              <Button
                type="default"
                icon={<DownloadOutlined />}
                onClick={() => this.downloadExcel(title, data, columns)}
                disabled={!data?.length}
              >
                Download Excel
              </Button>
              <Button
                type="default"
                icon={<FilePdfOutlined />}
                onClick={() => this.downloadPdf(title, data, columns)}
                loading={this.state.pdfDownloadLoading}
                disabled={!data?.length}
              >
                Download PDF
              </Button>
            </Space>
          </Col>
        </Row>

        {this.state.report4_API_loader ? (
          <Table
            loading={true}
            bordered
            columns={columns}
            dataSource={[]}
            rowKey={(record, index) => index}
            size="middle"
            scroll={{ x: 1400 }}
            pagination={false}
          />
        ) : data && data.length > 0 ? (
          <Table
            loading={false}
            bordered
            columns={columns}
            dataSource={data || []}
            rowKey={(record, index) => index}
            size="middle"
            scroll={{ x: 1400 }}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              onShowSizeChange: (current, size) => {
                // handle page size change here
                console.log("Page size changed to:", size);
              },
            }}
          />
        ) : (
          <Empty description={`No ${title} Data`} />
        )}
      </div>
    );
  };

  render() {
    const { startDate, data } = this.state;
    const { t } = this.context;
    const firColumns = [
      {
        title: (
          <div style={{ textAlign: "center", fontWeight: "700" }}>
            {t("sr.no")}
          </div>
        ),
        key: "sr_no",
        width: 70,
        align: "center",
        render: (text, record, index) => (
          <div style={{ fontWeight: 600 }}>{index + 1}</div>
        ),
      },

      {
        title: (
          <div style={{ textAlign: "center", lineHeight: "18px" }}>
            <div>{t("crime_police_station")}</div>
          </div>
        ),
        dataIndex: "crime_district",
        width: 260,
        render: (text, record) => (
          <div style={{ lineHeight: "22px", fontSize: "13px" }}>
            <div style={{ fontWeight: 600 }}>
              {record.crime_district || "-"}
            </div>

            <div>
              {record.registernumber || "-"} /
              {record.registernumberYear
                ? moment(record.registernumberYear).format("YYYY")
                : "-"}
            </div>

            <div>
              {record.report_date
                ? moment(record.report_date).format("DD/MM/YYYY")
                : "-"}
            </div>
          </div>
        ),
      },

      {
        title: (
          <div style={{ textAlign: "center", lineHeight: "18px" }}>
            <div>{t("law_and_section")}</div>
          </div>
        ),
        dataIndex: "district_name",
        width: 350,
        render: (text, record) => {
          const groupedData = {};

          record?.kk_info?.forEach((item) => {
            if (!groupedData[item.rulesName]) {
              groupedData[item.rulesName] = new Set();
            }

            groupedData[item.rulesName].add(item.kalam);
          });

          const rulesText = Object.keys(groupedData)
            .map((ruleName) => {
              const kalams = Array.from(groupedData[ruleName]).join(", ");
              return `${ruleName} - ${kalams}`;
            })
            .join(" | ");

          return (
            <div style={{ lineHeight: "22px", fontSize: "13px" }}>
              <div style={{ marginBottom: 6 }}>{rulesText || "-"}</div>

              {record.investigating_officer && (
                <div>
                  <b>{t("investigating_officer")}:</b>{" "}
                  {record.investigating_officer}
                </div>
              )}

              {record.mobile_no && (
                <div>
                  <b>{t("mobile_no")}:</b> {record.mobile_no}
                </div>
              )}
            </div>
          );
        },
      },

      {
        title: (
          <div style={{ textAlign: "center", lineHeight: "18px" }}>
            <div>{t("name_of_the_accused")}</div>
          </div>
        ),
        dataIndex: "name",
        width: 320,
        render: (text, record) => (
          <div style={{ lineHeight: "22px", fontSize: "13px" }}>
            <div style={{ fontWeight: 600 }}>{record.name || "-"}</div>

            {record.age && (
              <div>
                <b>{t("age")}:</b> {record.age}
              </div>
            )}

            {record.address && (
              <div>
                <b>{t("address")}:</b> {record.address}
              </div>
            )}

            <div>
              <b>{t("arrest1")}:</b>{" "}
              {record.accused_arrested === "Yes" ? t("yes") : t("no")}
            </div>
          </div>
        ),
      },

      {
        title: (
          <div style={{ textAlign: "center", fontWeight: "700" }}>
            {t("incident_details")}
          </div>
        ),
        dataIndex: "memberName",
        key: "memberName",
        width: 250,
        render: (text) => (
          <div style={{ lineHeight: "22px", fontSize: "13px" }}>
            {text || "-"}
          </div>
        ),
      },
    ];

    const arrestColumns = [
      {
        title: t("sr.no"),
        key: "sr_no",
        render: (text, record, index) => index + 1,
      },

      {
        title: t("police_station_of_crime"),
        dataIndex: "crime_district",
        render: (text, record) => {
          const groupedData = {};

          record?.kk_info?.forEach((item) => {
            if (!groupedData[item.rulesName]) {
              groupedData[item.rulesName] = new Set();
            }

            groupedData[item.rulesName].add(item.kalam);
          });

          const rulesText = Object.keys(groupedData)
            .map((ruleName) => {
              const kalams = Array.from(groupedData[ruleName]).join(", ");
              return `${ruleName} - ${kalams}`;
            })
            .join(" | ");

          return (
            <div style={{ lineHeight: "22px", fontSize: "13px" }}>
              <div style={{ fontWeight: 600 }}>
                {record.crime_district || "-"}
              </div>

              <div>
                {record.registernumber || "-"} /
                {record.registernumberYear
                  ? moment(record.registernumberYear).format("YYYY")
                  : "-"}
              </div>
              <div>{rulesText}</div>
            </div>
          );
        },
      },
      {
        title: t("accused_name"),
        dataIndex: "name",
        render: (text, record) => (
          <div style={{ lineHeight: "22px", fontSize: "13px" }}>
            <div style={{ fontWeight: 600 }}>{record.name || "-"}</div>

            {record.criminal_dob && (
              <div>
                <b>{t("accused_dob")}:</b>{" "}
                {moment(record.criminal_dob).format("DD/MM/YYYY")}
              </div>
            )}
            {record.aadharno && (
              <div>
                <b>{t("aadhaar_number")}:</b>
                {record.aadharno}
              </div>
            )}
            {record.mobileNumber && (
              <>
                <div>
                  <b>{t("mobile_number")}</b>
                  {record.mobileNumber}
                </div>
              </>
            )}
          </div>
        ),
      },
      {
        title: t("arrest_date"),
        dataIndex: "report_date",
        key: "report_date",
        render: (text) => (text ? moment(text).format("DD/MM/YYYY") : "-"),
      },
      {
        title: t("photo"),
        key: "Photo",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.image ? (
              <>
                <img
                  style={{ width: 50, height: 50 }}
                  src={
                    "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                    record.image
                  }
                  onClick={() =>
                    this.openImageModal(record.image, record.name, record.id)
                  }
                ></img>
              </>
            ) : (
              "नाही"
            )}
          </Space>
        ),
      },
    ];

    const noticeColumns = [
      {
        title: t("sr.no"),
        key: "sr_no",
        render: (text, record, index) => index + 1,
      },

      {
        title: t("notice_police"),
        dataIndex: "notice_district",
        key: "notice_district",
        render: (text, record) => (
          <div style={{ lineHeight: "22px", fontSize: "13px" }}>
            {record.notice_date && (
              <>
                <div>
                  <b>{t("notice_date")}: </b>
                  {moment(record.notice_date).format("DD/MM/YYYY")}
                </div>
              </>
            )}

            <div>
              <b>{t("crime_police_station")}: </b>
              {record.notice_district}
            </div>
            {record.registernumber && (
              <div>
                <b>{t("cr.no")}: </b>
                {record.registernumber}/
                {moment(record.registernumberYear).format("YYYY")}
              </div>
            )}
          </div>
        ),
      },
      {
        title: t("accused_name"),
        dataIndex: "name",
        render: (text, record) => (
          <div style={{ lineHeight: "22px", fontSize: "13px" }}>
            <div style={{ fontWeight: 600 }}>{record.name || "-"}</div>

            {record.aaropi_aadhar_number && (
              <div>
                <b>{t("aadhaar_number")}: </b>
                {record.aaropi_aadhar_number}
              </div>
            )}
            {record.mobileNumber && (
              <>
                <div>
                  <b>{t("mobile_no")}: </b>
                  {record.mobileNumber}
                </div>
              </>
            )}
          </div>
        ),
      },
      {
        title: t("investigating_officer"),
        dataIndex: "investigating_officer",
        render: (text, record) => (
          <div style={{ lineHeight: "22px", fontSize: "13px" }}>
            <div style={{ fontWeight: 600 }}>
              {record.investigating_officer || "-"}
            </div>

            {record.aaropi_number && (
              <>
                <div>
                  <b>{t("mobile_number")}: </b>
                  {record.aaropi_number}
                </div>
              </>
            )}
          </div>
        ),
      },
    ];

    const preventiveColumns = [
      {
        title: t("sr.no"),
        key: "sr_no",
        render: (text, record, index) => index + 1,
      },
      {
        title: t("action_taken_police_station"),
        dataIndex: "action_taken_police_station",
        key: "action_taken_police_station",
      },
      {
        title: t("accused_name"),
        dataIndex: "name",
        render: (text, record) => (
          <div style={{ lineHeight: "22px", fontSize: "13px" }}>
            <div style={{ fontWeight: 600 }}>{record.name || "-"}</div>

            <div>
              <b>{t("age")}: </b>
              {record.age}
            </div>
          </div>
        ),
      },
      {
        title: t("preventive_action"),
        dataIndex: "preventive_name",
        key: "preventive_name",
      },
      {
        title: t("date"),
        dataIndex: "date_from",
        key: "date_from",
        render: (text, record) => (
          <div style={{ lineHeight: "22px", fontSize: "13px" }}>
            <div>
              <b>{t("period_from")}: </b>
              {moment(record.date_from).format("DD/MM/YYYY")}
            </div>
            <div>
              <b>{t("period_to")}: </b>
              {moment(record.date_to).format("DD/MM/YYYY")}
            </div>
          </div>
        ),
      },
    ];

    const ncrColumns = [
      {
        title: t("sr.no"),
        key: "sr_no",
        render: (text, record, index) => index + 1,
      },
      {
        title: t("accused_police_station"),
        dataIndex: "districtName",
        key: "districtName",
      },
      {
        title: t("name"),
        dataIndex: "name",
        key: "name",
      },
      {
        title: t("age"),
        dataIndex: "age",
        key: "age",
      },
      {
        title: t("total_crimes"),
        dataIndex: "totalCrimeCount",
        key: "totalCrimeCount",
      },
    ];

    return (
      <>
        <div className="container-fluid">
          <div className="col-md-12">
            <div className="site-page-header-ghost-wrapper">
              <PageHeader
                className="site-page-header"
                ghost={false}
                onBack={false}
                title={t("daily_reports")}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <DatePicker
                    style={{ width: "250px" }}
                    value={startDate ? moment(startDate) : null}
                    onChange={this.onStartDateChange}
                    placeholder="DD/MM/YYYY"
                    allowClear
                    format={"DD/MM/YYYY"}
                    inputReadOnly
                  />

                  <Button type="primary" onClick={this.dailyReports}>
                    {t("find")}
                  </Button>
                </div>
              </PageHeader>
            </div>

            {/* FIR TABLE */}
            {this.renderTableSection("FIR", data.FIR, firColumns)}

            {/* ARREST TABLE */}
            {this.renderTableSection("Arrest", data.Arrest, arrestColumns)}

            {/* NOTICE TABLE */}
            {this.renderTableSection("Notice", data.Notice, noticeColumns)}

            {/* PREVENTIVE ACTION TABLE */}
            {this.renderTableSection(
              "Preventive Action",
              data.PreventiveAction,
              preventiveColumns,
            )}

            {/* NCR TABLE */}
            {this.renderTableSection("NCR", data.NCR, ncrColumns)}
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;

  const { user } = authentication;

  return {
    user,
    users,
    professionals,
  };
}

const connectedDailyReports = connect(mapStateToProps)(NewDailyReports);

export { connectedDailyReports as DailyReports };
